export default __webpack_public_path__ + "static/media/landlord-men.796198d7.svg";